<template>
  <div>
    <vs-row class="mb-5" vs-type="flex" vs-justify="flex-end">
      <vs-col
        vs-xs="1"
        vs-sm="1"
        vs-md="1"
        vs-lg="1"
        vs-type="flex"
        vs-justify="end"
        vs-align="end"
      >
        <x-icon class="ml-2 pointer" @click="handleClose"></x-icon>
      </vs-col>
    </vs-row>
    <vs-row class="mb-5" vs-type="flex" vs-justify="flex-end">
      <vs-col
        vs-xs="12"
        vs-sm="9"
        vs-md="9"
        vs-lg="9"
        vs-type="flex"
        vs-justify="start"
        vs-align="start"
      >
        <span class="card-header-title">{{ title | capitalize }}</span>
      </vs-col>
      <vs-col
        vs-xs="12"
        vs-sm="3"
        vs-md="3"
        vs-lg="3"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
      >
        <vs-input
          icon-pack="feather"
          icon="icon-search"
          :placeholder="$t('search')"
          v-model="content"
          @input="handleInput"
          @keyup.enter="handleEnter"
          class="qb-search w-full"
        />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'
export default {
  components: {
    XIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      content: this.value,
    }
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content)
    },
    handleEnter() {
      this.$emit('search')
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style>
/* .qb-search.input {
  border-radius: 20px;
} */


.card-header-title{
  font-size: 20px;
  font-weight: bold;
}
</style>